import { render, staticRenderFns } from "./SystemDemandResponse.vue?vue&type=template&id=4641632a&"
import script from "./SystemDemandResponse.vue?vue&type=script&lang=js&"
export * from "./SystemDemandResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4641632a')) {
      api.createRecord('4641632a', component.options)
    } else {
      api.reload('4641632a', component.options)
    }
    module.hot.accept("./SystemDemandResponse.vue?vue&type=template&id=4641632a&", function () {
      api.rerender('4641632a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SystemDemandResponse.vue"
export default component.exports